import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { PollParserInboxesStatisticsDto } from 'src/app/core/api/models';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { DoughnutChartModule } from "../../../../../../shared/components/charts/doughnut-chart/doughnut-chart.module";

@Component({
    selector: 'app-parser-stats-pie-chart',
    templateUrl: './parser-stats-pie-chart.component.html',
    styleUrls: ['./parser-stats-pie-chart.component.scss'],
    imports: [BaseFormModule, DoughnutChartModule]
})
export class ParserStatsPieChartComponent implements OnInit {
  public chart: any;

  @Input() model: PollParserInboxesStatisticsDto;
  @Input() chartId: string = '';

  labels: string[] = [];
  colors: string[] = [];
  data: number[] = [];
  title: string = this.translateService.instant(
    'pages.pollParsers.stats.pieChartTitle'
  );

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] || changes['chartId']) {
      if (this.model.totalAnswerCount > 0 && this.chartId.length > 0) {
        this.setData();
      }
    }
  }

  setData() {
    this.data = [
      this.model.correctAnswerCount,
      this.model.incorrectAnswerCount,
    ];
    this.labels = [
      this.translateService.instant(
        'pages.pollParsers.stats.correctAnswerCount'
      ),
      this.translateService.instant(
        'pages.pollParsers.stats.incorrectAnswerCount'
      ),
    ];
    this.colors = ['#0c3', '#c33'];
  }
}
